<template>
<div id="media_picker_menu">

   <div class="dropdown-container">
      <category-sort-dropdown 
         :reset="resetCategory" 
         :label="'category'" 
         @sortChanged="handleNewCategory">
      </category-sort-dropdown>

      <span class='asset-search'>
         <input type='text' v-model="searchKeyword" v-on:keyup.enter="handleSearch"/>
         <button class="search-btn" style="" @click="toggleInstanceKeyword()"></button>
      </span>
   </div>

   <div class="v-bar-container mp-menu" v-bar>
      <div class="asset-table">

         <m-p-recent-assets
            :sortByCategory="sortCategory"
            :enterSearch="enterSearch"
            :searchKeyword="searchKeyword"
            :searchTrigger="searchTrigger"
            :activeAssetId="activeAssetId"
            :isScoreboard="isScoreboard">
         </m-p-recent-assets>
         
         <m-p-active-assets
            :channelRecid="channelRecid"
            :isScoreboard="isScoreboard">
         </m-p-active-assets>

      </div>
   </div>
</div>
</template>

<script>
import MPActiveAssets from './MPActiveAssets';
import MPRecentAssets from './MPRecentAssets';

import CategorySortDropdown from './../CategorySortDropdown';

import { mapActions, mapState } from 'vuex';

export default {
   data() {
      return {
         sortCategory: '',
         searchKeyword: '',
         enterSearch: false,
         searchTrigger: false,
         resetCategory: false      
      }
   },

   props: {
      activeAssetId: String | Number,
      channelRecid: String | Number,
      isScoreboard: Boolean
   },

   created() {
      this.$on('SortChanged', (categoryId) => {
         this.sortCategory = categoryId;
      });
   },

   computed: {
      ...mapState('global', [
         'mpAssetType'
      ])
   },

   methods: {
      ...mapActions('global', [
         'changeCurrCategory',
         'changeCurrSearch'
      ]),

      handleSearch() {
         // if (this.searchKeyword != '') {
         //    // if (this.enterSearch) {
         //    //    this.searchTrigger = !this.searchTrigger;
         //    // } else {
         //    //    this.enterSearch = true;
         //    // }
         // } else {
         //    this.enterSearch = false;
         // }
         this.changeCurrSearch({searchTerm: this.searchKeyword})
      },

      handleNewCategory(category) {
         this.changeCurrCategory({category});
      }
   },

   watch: {
      mpAssetType() {
         this.searchKeyword = '';
         this.sortCategory = '';
         this.resetCategory = !this.resetCategory;
      }
   },

   components: {
      MPActiveAssets,
      MPRecentAssets,

      CategorySortDropdown
   }

}
</script>

<style lang="scss" scoped>
#media_picker_menu {
   padding-top: 20px;
   padding-left: 15px;
   padding-right: 20px;
   background: $bard-blue;
   height: 100%;

   .asset-table {
      max-height: 744px;
      min-height: 744px;

      &::after {
         content: '';
         width: 4px;
         height: 100%;
         position: absolute;
         right: .5em;
         top: 0;
         z-index: 1;
         background-color: #333e51;
      }
   }

   .mp-menu {
      &.vb-invisible {
         .asset-table {
            &::after {
            background-color: transparent;
            }
         }
      }
   }

   .asset-table > div:first-child {
      margin-bottom: 20px;
   }
}

.v-bar-container {
   //max-height: 752px;
}

.dropdown-container {
   margin-bottom: 20px;
   display: flex;
   justify-content: space-between;
   font-size: 14px;
}

.asset-search {
   background: $bard-gold;
   width: 155px;
   display: flex;
   align-items: center;

   input {
      box-shadow: none;
      border: none;
      border-radius: 0;
      background: transparent;
      width: 83%;

      &:focus {
         outline: none;
         border: none;
      }
   }

   .search-btn {
      width: 16px; 
      height: 16px; 
      margin-left: 4px;
      float: right;
      border: none; 
      background: url('../../assets/img/magnifying-glass-inst.svg') no-repeat center center transparent; 
   }
}

.sort-wrapper {
  padding-left: 0;
  position: absolute;
  right: 0;

  button {
      width: 170px;
      padding-left: 14px;
      border: 1px solid #313d50;
      border-radius: 4px; 
      background: url('../../assets/img/instances/SVGs/thin-arrow-right.svg') no-repeat 90% center #273143;
      background-size: 7px 12px; 
      text-align: left;
      color: white;
      cursor: pointer;

      &:focus {
        background-image: url('../../assets/img/instances/SVGs/thin-arrow-down.svg'); 
        background-size: 12px 7px; 
        outline: none;
      }
  }

  #sort_list {
    border: 1px solid #313d50;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    background-color: #273143;
    color: white;

    a {
      display: block;
      padding-left: 14px;
      text-decoration: none;
      border-bottom: 2px solid #313d50;
      line-height: 30px;
      font-size: 14px;
      color: inherit;
      cursor: pointer;

      &:hover {
        background-color: #2c374a; 
        color: #1c95db; 
      }

      &:last-of-type {
        border-bottom: 0;
      }
    }
  }
}
</style>
